<template>
  <div>
    <v-dialog v-model="couponSettingDialog" max-width="680">
      <v-card>
        <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold">자동변경 회원등급 선택</v-card-title>

        <v-card-text class="pl-5 pb-0">
          <p class="mb-0">
            설정에 따라 회원등급을 자동 변경합니다.
          </p>
        </v-card-text>

        <v-radio-group v-model="type" class="px-5 pt-0 mt-5 mb-3" hide-details="">
          <div class="d-flex">
            <v-radio style="display: inline;" value="all" :disabled="is_type_all"></v-radio>
            <label class="mr-10 grey--text" v-if="is_type_all">정품 인증할때 쿠폰 발급</label>
            <label class="mr-10" v-else>정품 인증할때 쿠폰 발급</label>
            <v-radio style="display: inline;" value="product"></v-radio>
            <label class="">특정 상품을 정품 인증할때 쿠폰 발급</label>
          </div>
        </v-radio-group>

        <div v-if="type == 'product'" class="px-5 pb-5">
          <v-autocomplete
            v-model="serialProductModal"
            :items="product_items"
            item-text="product_name"
            item-value="product_no"
            label="상품명을 입력해주세요."
            no-data-text="조회된 상품이 없습니다"
            outlined
            hide-details
            height="40"
            dense
          ></v-autocomplete>
        </div>

        <v-select
          placeholder="쿠폰 선택"
          outlined
          single-line
          hide-details
          class="px-5 mb-0"
          v-model="couponModal"
          :items="couponItems"
          item-text="coupon_name"
          item-value="coupon_no"
          dense
        ></v-select>

        <v-btn color="black" hide-details depressed class="white--text ml-5" @click="couponSettingDialog = false" width="316">닫기</v-btn>

        <v-btn
          color="primary"
          hide-details
          class="white--text ml-2 mt-5 mb-5 pl-4 pr-4 mr-5"
          depressed
          @click="couponMatching()"
          width="316"
          >설정</v-btn
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data: () => {
    return {
      couponSettingDialog: false,
      couponItems: [],
      couponModal: "",
      type: "all",
      serialProductModal: "",
      serialProductList: [],
      product_headers: [
        {
          text: "상품번호",
          align: "cetner",
          value: "product_no",
          sortable: false,
        },
        {
          text: "상품명",
          align: "cetner",
          value: "product_name",
          sortable: false,
        },
      ],
      product_items: [],
      search: null,
      is_type_all: false,
    };
  },
  methods: {
    reset: function() {
      Object.assign(this.$data, this.$options.data());
    },
    show: async function() {
      this.reset();
      this.getTypeAll();
      await this.searchCoupon();
      await this.getSerialProducts();
    },
    getTypeAll: function() {
      let typeAllCount = 0;
      for (const coupon of this.$parent.coupons) {
        if (coupon.type == "all") {
          typeAllCount++;
        }
      }
      // type='all' 쿠폰이 5개에 도달하면 더 이상 추가 불가
      if (typeAllCount >= 5) {
        this.is_type_all = true;
      }
      if (this.is_type_all === true) {
        this.type = "product";
      }
    },
    couponMatching: async function() {
      if (this.type == "product" && !this.serialProductModal) {
        alert("정품 인증 코드 생성된 상품을 선택해주세요.");
        return;
      }
      if (!this.couponModal) {
        alert("쿠폰을 선택해주세요.");
        return false;
      }
      let typeAllCount = 0;
      for (const coupon of this.$parent.coupons) {
        if (coupon.type == "all") {
          typeAllCount++;
        }
        if (this.type == "product" && Number(coupon.product_no) == Number(this.serialProductModal)) {
          alert("이미 등록된 상품입니다.");
          return;
        }
      }
      // type='all' 쿠폰은 최대 5개까지 허용
      if (this.type == "all" && typeAllCount >= 5) {
        alert("정품 인증 쿠폰은 최대 5개까지 설정 가능합니다.");
        return;
      }

      let info = this.couponItems.find((item) => item.coupon_no === this.couponModal);
      let product_info = { product_no: null, product_name: null };

      if (this.serialProductModal) {
        product_info = this.serialProductList.find((item) => Number(item.product_no) === Number(this.serialProductModal));
      }

      let coupon_exception_list = [];
      if (this.$parent.coupons.coupon_exception_list && this.$parent.coupons.coupon_exception_list.length > 0) {
        coupon_exception_list = this.$parent.coupons.coupon_exception_list;
      }

      if (typeof product_info.product_name === "string") {
        product_info.product_name = product_info.product_name.replace(/<\/?[^>]+(>|$)/g, "");
      }
      this.$parent.coupons.push({
        coupon_name: info.coupon_name,
        coupon_no: info.coupon_no,
        type: this.type,
        product_no: product_info.product_no,
        product_name: product_info.product_name,
        coupon_exception_list: coupon_exception_list,
      });

      this.couponSettingDialog = false;
      alert("설정되었습니다.");
    },
    //리스트 조회
    searchCoupon: async function() {
      try {
        let result = await M.api(M.entry("/get/coupons"));
        this.couponItems = result;
        this.couponSettingDialog = true;
      } catch (e) {
        alert("조회되지 않았습니다.");
        this.couponSettingDialog = false;
      }
    },
    // 정품-인증-코드-생성된-상품-리스트-조회
    getSerialProducts: async function() {
      if (this.product_items.length > 0) {
        return;
      } else {
        this.serialProductList = await this.$parent.getSerialProducts("coupon");
        for (const product of this.serialProductList) {
          let find_product = this.$parent.coupons.find((e) => Number(e.product_no) == Number(product.product_no));
          if (find_product) {
            continue;
          }
          if (typeof product.product_name === "string") {
            // Remove HTML tags from product_name
            product.product_name = product.product_name.replace(/<\/?[^>]+(>|$)/g, "");
          }
          this.product_items.push(product);
        }
      }
      /*
      try {
        this.serialProductList = await M.api(M.entry("/get/serials/products"));
        for (const product of this.serialProductList) {
          let find_product = this.$parent.coupons.find(
            (e) => Number(e.product_no) == Number(product.product_no)
          );
          if (find_product) {
            continue;
          }
          this.product_items.push(product);
        }
      } catch (e) {
        alert("조회되지 않았습니다.");
      }
        */
    },
  },
  mixins: [CommonMixin],
};
</script>
